var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88128 0.430664C2.36571 0.430664 0.319092 2.47728 0.319092 4.99285C0.319092 8.15466 4.88577 13.5557 4.88577 13.5557C4.88577 13.5557 9.44347 7.99917 9.44347 4.99285C9.44347 2.47728 7.39693 0.430664 4.88128 0.430664ZM6.25779 6.32866C5.87823 6.70814 5.3798 6.89791 4.88128 6.89791C4.38284 6.89791 3.88425 6.70814 3.50485 6.32866C2.74582 5.56971 2.74582 4.33476 3.50485 3.57573C3.87239 3.20803 4.36129 3.00552 4.88128 3.00552C5.40126 3.00552 5.89009 3.20811 6.25779 3.57573C7.01682 4.33476 7.01682 5.56971 6.25779 6.32866Z",
    fill: "#3CBD96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.8e3719e8ce0bbfcfe644b6fe7f45f58a.svg";
export { ForwardRef as ReactComponent };